export const FONT_WEIGHT_BOLD = "bold";
export const FONT_WEIGHT_BOLDER = "bolder";
export const FONT_WEIGHT_LIGHT = "light";
export const FONT_WEIGHT_NORMAL = "normal";

export const TYPOGRAPHY_FONT_WEIGHTS = {
  light: 300,
  normal: 400,
  bold: 500,
  bolder: 600,
} as const;

export const TEXT_SM = "sm";
export const TEXT_MD = "md";
export const TEXT_LG = "lg";

export const TEXT_FONT_SIZES = {
  sm: TEXT_SM,
  md: TEXT_MD,
  lg: TEXT_LG,
} as const;

export const BOOTSTRAP_FONT_WEIGHTS = {
  300: "font-weight-light",
  400: "font-weight-normal",
  500: "font-weight-bold",
  600: "font-weight-bolder",
} as const;

export const TITLE_LEVELS = ["1", "2", "3", "4", "5"] as const;

export type FontSizeType = keyof typeof TEXT_FONT_SIZES;
export type FontWeightType = keyof typeof TYPOGRAPHY_FONT_WEIGHTS;
export type LevelType = (typeof TITLE_LEVELS)[number];
